import { pickAppCopy, type SupportedLocale } from "@patient-watch/i18n";
import { useAppLocale } from "./LocaleContext";
import { analyticsCopyEn, localizeDashboardViewName } from "@patient-watch/i18n/webapp/en-GB/analyticsCopy";
import { analyticsCopyDe } from "@patient-watch/i18n/webapp/de-DE/analyticsCopy";
import { analyticsCopyDa } from "@patient-watch/i18n/webapp/da-DK/analyticsCopy";
import { analyticsCopyEnUs } from "@patient-watch/i18n/webapp/en-US/analyticsCopy";
import { analyticsCopyFr } from "@patient-watch/i18n/webapp/fr-FR/analyticsCopy";
import { analyticsCopyIt } from "@patient-watch/i18n/webapp/it-IT/analyticsCopy";
import { analyticsCopyEs } from "@patient-watch/i18n/webapp/es-ES/analyticsCopy";

export type AnalyticsCopy = typeof analyticsCopyEn;
const analyticsCopy: Record<SupportedLocale, AnalyticsCopy> = {
    "en-GB": analyticsCopyEn,
    "en-US": analyticsCopyEnUs,
    "de-DE": analyticsCopyDe,
    "da-DK": analyticsCopyDa,
    "fr-FR": analyticsCopyFr,
    "it-IT": analyticsCopyIt,
    "es-ES": analyticsCopyEs,
};

export function useAnalyticsCopy(): AnalyticsCopy {
    const { locale } = useAppLocale();
    return pickAppCopy(analyticsCopy, locale);
}

export function getAnalyticsCopy(locale: SupportedLocale): AnalyticsCopy {
    return pickAppCopy(analyticsCopy, locale);
}

export { localizeDashboardViewName };
